import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { line as d3Line, curveLinear as d3CurveLinear } from 'd3-shape';

export default class ClippedImage extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    url: PropTypes.string.isRequired
  };

  static defaultProps = {
    borderColor: '#ffffff',
    borderWidth: '10'
  };

  constructor(props) {
    super(props);

    this.state = {
      id: props.id,
      width: props.width,
      height: props.height,
      borderColor: props.borderColor,
      borderWidth: props.borderWidth,
      url: props.url
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.state.url !== props.url) {
      this.setState({ url: props.url });
    }
  }

  render() {
    const { id, width, height, url, borderColor, borderWidth } = this.state;

    const borderScale = (width - 2 * borderWidth) / width;

    const shapeData = [
      { x: 0, y: 0 },
      { x: width, y: 0 },
      { x: width, y: height * 0.75 },
      { x: width / 2, y: height },
      { x: 0, y: height * 0.75 },
      { x: 0, y: 0 }
    ];

    const lineFunction = d3Line()
      .x(d => d.x)
      .y(d => d.y)
      .curve(d3CurveLinear);

    const paths = lineFunction(shapeData);

    return (
      <svg width={width} height={height}>
        <defs>
          <clipPath id={'avatarClipPath' + id}>
            <path d={paths} />
          </clipPath>
        </defs>
        <g fill={borderColor}>
          <path d={paths} />
        </g>
        <g
          clipPath={'url(#avatarClipPath' + id + ')'}
          transform={`translate(${borderWidth}, ${borderWidth}), scale(${borderScale})`}
        >
          <image
            x={0}
            y={0}
            width={width}
            height={height}
            href={url}
            preserveAspectRatio="xMidYMid slice"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ClippedImage/ClippedImage.js